"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var voucherStoreValidator = (0, _validation.createValidator)({
  first_name: _validation.required,
  last_name: _validation.required,
  address: _validation.required,
  postal_code: _validation.required,
  city: _validation.required,
  email: [_validation.required, _validation.email],
  phone: _validation.required
});
exports.default = (0, _lruMemoize2.default)(10)(voucherStoreValidator);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/VoucherStore/voucherStoreValidator.js
 ** module id = 492
 ** module chunks = 0
 **/